import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import CalendarPage from '../views/CalendarPage.vue'
import FileMergePage from '../views/FileMergePage.vue'
import FeedbackPage from '../views/FeedbackPage.vue'
import ApiDocPage from '../views/ApiDocPage.vue'
import PasswordGeneratorPage from '../views/PasswordGeneratorPage.vue'
import MiniGamesPage from '../views/MiniGamesPage.vue'
import GamePlayPage from '../views/GamePlayPage.vue'
import DemosPage from '../views/DemosPage.vue'
import KeyboardCleanPage from '../views/KeyboardCleanPage.vue'
import ImageComparePage from '../views/ImageComparePage.vue'
import { authBus } from '../store/auth'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', name: 'home', component: HomePage, meta: { title: '工具箱' } },
  { path: '/calendar', name: 'calendar', component: CalendarPage, meta: { title: '日历查询' } },
  { path: '/file-merge', name: 'file-merge', component: FileMergePage, meta: { title: '文件合并' } },
  { path: '/password-generator', name: 'password-generator', component: PasswordGeneratorPage, meta: { title: '密码生成器', requiresAuth: true } },
  { path: '/games', name: 'games', component: MiniGamesPage, meta: { title: '小游戏' } },
  { path: '/games/play/:id', name: 'game-play', component: GamePlayPage, meta: { title: '小游戏' } },
  { path: '/demos', name: 'demos', component: DemosPage, meta: { title: '教育演示' } },
  { path: '/keyboard-clean', name: 'keyboard-clean', component: KeyboardCleanPage, meta: { title: '键盘清洁' } },
  { path: '/image-compare', name: 'image-compare', component: ImageComparePage, meta: { title: '图片对比' } },
  { path: '/feedback', name: 'feedback', component: FeedbackPage, meta: { title: '留言' } },
  { path: '/calendar-access', name: 'calendar-access', component: ApiDocPage, meta: { title: '日历接入' } }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    next()
    return
  }
  if (authBus.isLoggedIn && authBus.user) {
    next()
    return
  }
  if (await authBus.syncLoginStatus()) {
    next()
    return
  }
  next({ path: '/home', query: { login: 'required' } })
})

export default router
